module.exports = __webpack_public_path__ + "img/page-home-container2-title.b98fe0d6.png";